var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"color":"white--text","items":_vm.items,"label":"Add an option","prepend-icon":"settings","item-value":"name"},on:{"change":_vm.selectOption},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('div',[_c('p',{staticClass:"select_name"},[_vm._v(_vm._s(item.name))]),_c('p',{staticClass:"select_tooltip"},[_vm._v(_vm._s(item.tooltip))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }